import request from '@/utils/request.js'

// 获取车辆列表
export const getVehiclePageList = (data) => {
  return request({
    url: '/cloud/vehicle/pageList',
    method: 'post',
    data: data
  })
}

// 获取车辆详情
export const getVehicleInfo = (vehicleId) => {
  return request({
    url: '/cloud/vehicle/info?vehicleId=' + vehicleId,
    method: 'get'
  })
}

// 新增车辆报备
export const addVehicle = (data) => {
  return request({
    url: '/cloud/vehicle/add',
    method: 'post',
    data: data
  })
}

// 更新车辆信息
export const updateVehicle = (data) => {
  return request({
    url: '/cloud/vehicle/update',
    method: 'post',
    data: data
  })
}

// 车辆号牌绑定/变更
export const bindVehicleLicence = (data) => {
  return request({
    url: '/cloud/vehicle/licence/bind',
    method: 'post',
    data: data
  })
}